/* eslint-disable @typescript-eslint/require-await */
// @ts-strict-ignore
import { Subscription } from 'rxjs/internal/Subscription';
import { SettingsService } from 'rainbow-web-sdk/services/core/settings.service';
import { ContactService } from 'rainbow-web-sdk/services/core/contact.service';
import { ProfileService } from 'rainbow-web-sdk/services/core/profile.service';
import { RBEvent } from 'rainbow-web-sdk/models/event.model';
import { BubbleServiceRB } from 'rainbow-web-sdk/services/bubbles/bubble.service';
import { DeviceManagementEvents, DeviceManagementServiceRB } from "rainbow-web-sdk/services/deviceManagement/deviceManagement.service";
import { EventService } from 'rainbow-web-sdk/services/core/event.service';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { Service } from 'rainbow-web-sdk/services/service';
import { WebrtcP2PService, WebrtcP2PServiceEvents } from 'rainbow-web-sdk/services/webrtc/webrtcP2P.service';
import { Contact } from 'rainbow-web-sdk/models/contact.model';
import { CallInfo, RingingSupervisedCall, SupervisionService } from 'rainbow-web-sdk/services/telephony/supervision.service';
import { TelephonyService } from 'rainbow-web-sdk/services/telephony/telephony.service';
import { BubbleConferenceServiceEvents, BubbleConferenceServiceRB } from 'rainbow-web-sdk/services/conference/bubbleConference.service';
import { PresenceHelperService } from 'rainbow-web-sdk/services/core/presenceHelper.service';
import { CallStatus } from 'rainbow-web-sdk/models/call.model';

export const RINGING_SVC = 'RingingService';

// export enum PersonalRoutineType {
export enum NotificationType {
    NOTIFICATIONTYPE_STANDARD = "std",
    NOTIFICATIONTYPE_LOW = "low",
    NOTIFICATIONTYPE_MIDDLE = "middle",
    NOTIFICATIONTYPE_HIGH = "high"
}

interface IAudioTone {
    audio: HTMLAudioElement;
    starting: boolean;
    stopDefered?: any;
    id?: string;
    type?: string;
}

export class RingingService extends Service {
    private settingsService: SettingsService = SettingsService.getInstance();
    private contactService: ContactService = ContactService.getInstance();
    private profileService: ProfileService = ProfileService.getInstance();
    private roomService: BubbleServiceRB = BubbleServiceRB.getInstance();
    private deviceManagementService: DeviceManagementServiceRB = DeviceManagementServiceRB.getInstance();
    private supervisionService: SupervisionService = SupervisionService.getInstance();
    private telephonyService: TelephonyService = TelephonyService.getInstance();
    private presenceHelperService: PresenceHelperService = PresenceHelperService.getInstance();

    private eventService: EventService = EventService.getInstance();
    private logger: LoggerService = LoggerService.getInstance();
    private webrtcP2PService: WebrtcP2PService = WebrtcP2PService.getInstance();
    private bubbleConferenceService: BubbleConferenceServiceRB = BubbleConferenceServiceRB.getInstance();

    // List of sound for Notification, Ringing and Alarms
    public notifs: string[] = [
        "noSound", "ding", "harp", "hello", "complete", "duck", "appointed", "chime", "stairs", "wet", "mcfly", "spies", "wilhelm", "important"
    ];

    public alarms: string[] = [
        "noRingtone", "lightBounce", "discovery", "lounge", "uptown", "morningLights", "miami", "farEast", "highSpeed", "rainDrops", "deepSpace",
        "steamTrain", "happy", "decrescendo", "strident", "peacefulness", "classic1", "classic2", "classic3", "cosy1", "cosy2", "cosy3", "dynamic1",
        "dynamic2", "dynamic3", "quiet1", "quiet2", "quiet3", "relax1", "relax2", "relax3", "socotel"
    ];

    // According to the profileService, the list of emergency alarms can be updated at the start of the service
    public emergencyAlarms: string[] = ["noSound", "pager1"];

    // Audio capability
    public audioFileType: string = "";

    // Audio resources

    // Basic HTMLAudioElement
    private recordTone: HTMLAudioElement = null;
    private joinWebConfTone: HTMLAudioElement = null;
    private alarmNotifOnce: HTMLAudioElement = null;
    private audioNotifOnce: HTMLAudioElement = null;
    private pingAudio: HTMLAudioElement = null;
    private pingAudioSecondary: HTMLAudioElement = null;
    private pushToTalkActivateTone: HTMLAudioElement = null;
    private pushToTalkDeactivateTone: HTMLAudioElement = null;
    private informationImSoundAudio: HTMLAudioElement = null;
    private informationImSoundAudioSecondary: HTMLAudioElement = null;
    private importantImSoundAudio: HTMLAudioElement = null;
    private importantImSoundAudioSecondary: HTMLAudioElement = null;
    private emergencyImSoundAudio: HTMLAudioElement = null;
    private emergencyImSoundAudioSecondary: HTMLAudioElement = null;
    private webrtcBusyTone: HTMLAudioElement = null; //RQRAINB-9062
    private webrtcRaiseHandTone: HTMLAudioElement = null; //RQRAINB-11035

    // HTMLAudioElement with context for specific management (defered, id ...)
    private incomingRingingTone: Partial<IAudioTone> = {};
    private incomingRingingSecondaryTone: Partial<IAudioTone> = {};
    private ringbackTone: Partial<IAudioTone> = {};
    private secondCallTone: Partial<IAudioTone> = {};
    private holdTone: Partial<IAudioTone> = {};
    public activeSupervisorRingingTone: Partial<IAudioTone> = {};
    public activeSupervisorRingingToneSecondary: Partial<IAudioTone> = {};
    public supervisorRingingToneOffRequested = false;

    // Sound for IM notification according to its type (information/important/emergency)
    public informationImSound: string = "";
    public importantImSound: string = "";
    public emergencyImSound: string = "";

    // Data for active notification (value from 'notifs) and alarm ( value from 'alarms')
    public activeNotif: string = "";
    public activeAlarm: string = "";

    // Store if a 'startIncomingRinging' request is already in progress or not
    private isStartIncomingRingingRequest: boolean = false;

    // Is this data really useful ?
    // Not sure as previously not initialized and never modified as 'stopIncomingWebrtcSounds' method not called
    private stopWebrtcSounds: boolean = false;

    private subscriptions: Subscription[] = [];
    private listeners: any[] = [];

    private alertSoundLevel = 0.4;
    private alertSoundLevelInCall = 0.2;

    public static getInstance() {
        return Service.create(RINGING_SVC, RingingService);
    }

    public static build() {
        return new RingingService();
    }

    private constructor() { super(); }

    /********************************************************/
    /** LIFE CYCLE STUFF                                   */
    /********************************************************/
    public async start(): Promise<void> {
        try {
            this.logger.info(`[ringingService] === STARTING ===`);

            // Set audio capability of the current browser
            this.setAudioCapability();

            // Create audio resources
            this.ringbackTone = { audio: new Audio(), starting: false, id: "ringbackTone" };
            this.recordTone = new Audio("/assets/sounds/beep-01a" + this.audioFileType);
            this.secondCallTone = { audio: new Audio("/assets/sounds/beep-beep" + this.audioFileType), starting: false, id: "secondCallTone" };
            this.joinWebConfTone = new Audio("/assets/sounds/join_meeting" + this.audioFileType);
            this.holdTone = { audio: new Audio("/assets/sounds/new-hold" + this.audioFileType), starting: false };
            this.pushToTalkActivateTone = new Audio("/assets/sounds/ptt_activate" + this.audioFileType);
            this.pushToTalkDeactivateTone = new Audio("/assets/sounds/ptt_deactivate" + this.audioFileType);
            this.webrtcBusyTone = new Audio("/assets/sounds/webrtcBusy-tone" + this.audioFileType); //RQRAINB-9062
            this.webrtcRaiseHandTone = new Audio("/assets/sounds/raise-hand-sound" + this.audioFileType);

            this.ringbackTone.audio.onloadeddata = () => { this.logger.info(`[ringingService] === ringbackTone -- loaded`); };
            this.ringbackTone.audio.oncanplay = () => { this.logger.info(`[ringingService] === ringbackTone -- oncanplay `); };
            this.ringbackTone.audio.onerror = () => { this.logger.error(`[ringingService] === ringbackTone -- onerror `); };
            this.ringbackTone.audio.src = "/assets/sounds/outgoing-rings" + this.audioFileType;
            this.ringbackTone.audio.currentTime = 0;
            this.ringbackTone.audio.loop = true;
            this.ringbackTone.audio.load();

            this.holdTone.audio.loop = true;
            this.secondCallTone.audio.loop = true;
            this.alarmNotifOnce = null;

            this.informationImSound = this.contactService.userContact.customData.informationImSound;
            if (!this.informationImSound) {
                this.informationImSound = this.settingsService.getSetting("informationImSound");
            }

            this.importantImSound = this.contactService.userContact.customData.importantImSound;
            if (!this.importantImSound) {
                this.importantImSound = this.settingsService.getSetting("importantImSound");
            }

            const activeSupervisorAlarm: string = this.contactService.userContact.customData.supervisorAlarm;
            const activeSupervisorAlarmType: string = this.contactService.userContact.customData.supervisorAlarmType || "notifs"; // "notifs" to stay compatible with old supervision alarm implementation

            this.manageEmergencyNotifs();

            const settingsActiveNotif: string = this.settingsService.getSetting("activeNotif");
            const settingsActiveAlarm: string = this.settingsService.getSetting("activeAlarm");
            const hasSecondRinger: boolean = this.settingsService.getSetting("hasSecondRinger") === "true";
            const playMessagingNotifOnSecondaryRinger: boolean = this.settingsService.getSetting("playMessagingNotifOnSecondaryRinger") === "true";
            this.setActive(settingsActiveNotif, settingsActiveAlarm, this.informationImSound, this.importantImSound, activeSupervisorAlarm, activeSupervisorAlarmType, hasSecondRinger, playMessagingNotifOnSecondaryRinger);

            this.addListeners();

            if (this.settingsService.getSetting("alertSoundLevel")) { this.alertSoundLevel = parseFloat(this.settingsService.getSetting("alertSoundLevel")); }
            if (this.settingsService.getSetting("alertSoundLevelInCall")) { this.alertSoundLevelInCall = parseFloat(this.settingsService.getSetting("alertSoundLevelInCall")); }

            this.logger.info(`[ringingService] === STARTED ===`);
        }
        catch (error) {
            this.logger.error(`[ringingService] === STARTING FAILURE === ${error.message}`);
        }
    }

    public async stop(): Promise<void> {
        this.logger.info(`[ringingService] === STOPPING ===`);

        // Remove listeners & subscriptions
        this.listeners.forEach((listener) => { listener(); });
        this.listeners = [];
        this.subscriptions.forEach((subscription: Subscription) => { subscription.unsubscribe(); });
        this.subscriptions = [];

        this.stopIncomingRinging();
        this.stopHoldTone();
        this.stopSecondCallTone();

        // Stop audio tone
        if (this.ringbackTone) { this.ringbackTone.starting = false; this.ringbackTone.audio = null; }
        if (this.incomingRingingTone) { this.incomingRingingTone.starting = false; this.incomingRingingTone.audio = null; }
        if (this.incomingRingingSecondaryTone) { this.incomingRingingSecondaryTone.starting = false; this.incomingRingingSecondaryTone.audio = null; }
        if (this.secondCallTone) { this.secondCallTone.starting = false; this.secondCallTone.audio = null; }
        if (this.holdTone) { this.holdTone.starting = false; this.holdTone.audio = null; }

        // Reset audio resources
        this.recordTone = null;
        this.joinWebConfTone = null;
        this.alarmNotifOnce = null;
        this.audioNotifOnce = null;
        this.pingAudio = null;
        this.pingAudioSecondary = null;
        this.pushToTalkActivateTone = null;
        this.pushToTalkDeactivateTone = null;
        this.informationImSoundAudio = null;
        this.informationImSoundAudioSecondary = null;
        this.importantImSoundAudio = null;
        this.importantImSoundAudioSecondary = null;
        this.emergencyImSoundAudio = null;
        this.emergencyImSoundAudioSecondary = null;
        this.webrtcBusyTone = null; //RQRAINB-9062
        this.webrtcRaiseHandTone = null;

        this.incomingRingingTone = {};
        this.incomingRingingSecondaryTone = {};
        this.ringbackTone = {};
        this.secondCallTone = {};
        this.holdTone = {};

        this.informationImSound = "";
        this.importantImSound = "";
        this.emergencyImSound = "";
        this.activeNotif = "";
        this.activeAlarm = "";

        this.logger.info(`[ringingService] === STOPPED ===`);
    }

    /********************************************************/
    /**                 EVENT HANDLING                     */
    /********************************************************/
    private addListeners() {
        this.listeners.push(this.eventService.subscribe("ON_PRESS_PUSH_TO_TALK_EVENT", this.playActivatePtT.bind(this)));
        this.listeners.push(this.eventService.subscribe("ON_RELEASE_PUSH_TO_TALK_EVENT", this.playDeactivatePtT.bind(this)));

        this.subscriptions.push(this.profileService.subscribe(() => { this.manageEmergencyNotifs(); }));
        this.subscriptions.push(this.webrtcP2PService.subscribe(() => { this.manageOnWebrtcBusy(); }, WebrtcP2PServiceEvents.RAINBOW_ON_WEBRTC_BUSY));//RQRAINB-9062

        this.subscriptions.push(this.bubbleConferenceService.eventSubscribe((event: RBEvent) => {
            const connectedUser = this.contactService.getConnectedUser();
            if (event.name === BubbleConferenceServiceEvents.ON_WEBCONFERENCE_PARTICIPANT_UPDATE && event.data.action === 'raise-hand' && connectedUser.dbId !== event.data.participant.id) {
                this.manageOnWebrtcRaiseHand();
            }
        }));

        this.subscriptions.push(this.deviceManagementService.subscribe((event: RBEvent) => {
            try {
                //update the current output for incoming ringing
                if (event.name === DeviceManagementEvents.ON_NEW_AUDIO_VIDEO_DEVICE_SELECTED && event.data.kind === "audiooutput") {
                    this.onAudioOutputDeviceChange();
                }
                else if (event.name === DeviceManagementEvents.ON_NEW_SECONDARY_OUTPUT_DEVICE_SELECTED) {
                    this.onSecondaryAudioOutputDeviceChange();
                }
            }
            catch {
                //do nothing
            }
        }));

        this.subscriptions.push(this.supervisionService.subscribe((event) => {
            try {
                if (!event) return;

                if (event.name === 'ON_SUPERVISION_CONTACT_CALLINFOS_UPDATED') {
                    if (this.activeSupervisorRingingTone?.type === "notifs") {
                        this.logger.info(`[ringingService][SUPERV] received ON_SUPERVISION_CONTACT_CALLINFOS_UPDATED supervised contact: '${event.data?.contact?.nameForLogs}' callinfos '${event.data?.contact?.supervisionCallInfos ? JSON.stringify(event.data?.contact?.supervisionCallInfos) : ''}'`);
                        // check the contact calls to see if an audio notification is needed
                        const contact: Contact = event.data?.contact;
                        if (contact) {
                            (contact.supervisionCallInfos || []).forEach((callInfo: CallInfo) => {
                                // Play the notif whatever the existing telephony call(s) on our client
                                if (callInfo.callState === "ringingIn" && !callInfo.notified) {
                                    this.logger.info(`[ringingService][SUPERV] notify supervisor notif for contact: '${contact.nameForLogs}' call: '${callInfo.callId}'`);
                                    // the audio notification is played if it's an incoming ringing call and if it's not already played for this call
                                    this.playSupervisorNotif();
                                    callInfo.notified = true;
                                }
                            });
                            this.logger.info(`[ringingService][SUPERV] received ON_SUPERVISION_CONTACT_CALLINFOS_UPDATED updated data for supervised contact: '${contact.nameForLogs}' callinfos '${event.data?.contact?.supervisionCallInfos ? JSON.stringify(event.data?.contact?.supervisionCallInfos) : ''}'`);
                        }
                    }
                }
                if (event.name === 'ON_SUPERVISION_RINGING_CONTACTS_UPDATED' && event.data?.op === "create_or_delete") {
                    if (this.activeSupervisorRingingTone?.type === "alarms") { // long ringingtone in infinite loop
                        this.logger.info(`[ringingService][SUPERV] received: ON_SUPERVISION_RINGING_CONTACTS_UPDATED`);
                        // Are there any ringing supervised users?
                        const completeRingingSupervisedCallList: RingingSupervisedCall[] = this.supervisionService.getRingingSupervisedCallList();
                        if (completeRingingSupervisedCallList.length > 0) {
                            // there is at least one ringing supervised user:
                            // play the supervisor audio notification if the supervisor has not asked to stop the supervisor ringing tone
                            if (!this.supervisorRingingToneOffRequested) {
                                const existTelIncomingCalls: boolean = this.telephonyService.getCalls([CallStatus.RINGING_INCOMMING, CallStatus.QUEUED_INCOMMING]).length > 0;
                                if (!existTelIncomingCalls) {
                                    // check if we must play the main supervisor ringing tone or the second call tone
                                    const playSecondaryRingingTone: boolean = (this.telephonyService.getCalls([CallStatus.ACTIVE, CallStatus.HOLD, CallStatus.PUT_ON_HOLD]).length > 0
                                        || this.webrtcP2PService.existWebrtcActiveSessionNotMP()
                                        || Boolean(this.bubbleConferenceService?.getActiveWebConferenceSession()));
                                    if (!playSecondaryRingingTone) { // and is not engaged in a call
                                        this.logger.info(`[ringingService][SUPERV] let's play main supervisor ringing tone`);
                                        this.playSupervisorRingingTone();
                                    } else {
                                        this.logger.info(`[ringingService][SUPERV] let's play second call tone`);
                                        this.playSecondCallTone();
                                    }
                                } else {
                                    this.logger.info(`[ringingService][SUPERV] ringing supervsed call present but no need to play ringing tone: the ringing tone is already played for existing telephony incoming call(s)`);
                                }
                            } else {
                                this.logger.info(`[ringingService][SUPERV] no supervisor tone played because ringing tone off has been requested`);
                            }
                        } else {
                            // there are no more ringing supervised users
                            // 1- stop the supervisor main ringing tone
                            this.logger.info(`[ringingService][SUPERV] stop main supervisor ringing tone`);
                            this.stopSupervisorRingingTone();

                            // 2 - stop the second call tone if it is not required for the telephony call(s):
                            // the second call tone is still required for telephony if some tel active call(s) and some tel incoming call(s) exist, and must be maintained
                            if (!(this.telephonyService.getCalls([CallStatus.ACTIVE, CallStatus.HOLD]).length > 0
                                  && this.telephonyService.getCalls([CallStatus.RINGING_INCOMMING, CallStatus.QUEUED_INCOMMING]).length > 0)) {
                                this.logger.info(`[ringingService][SUPERV] stop second call tone because no more supervised ringing calls and no telephone calls requiring second tone`);
                                this.stopSecondCallTone();
                            } else {
                                this.logger.info(`[ringingService][SUPERV] second call tone not stopped because it is still required by telephony`);
                            }

                            // reset supervisorRingingToneStopped in order to be able to play again the supervisor ringing tone
                            // for the next supervised ringing calls
                            this.supervisorRingingToneOffRequested = false;
                        }
                    }
                }
            }
            catch (_err) {
                // do nothing
            }
        }));
    }

    private async onAudioOutputDeviceChange() {
        if (this.incomingRingingTone?.audio) {
            if (!this.incomingRingingTone.audio.paused) {
                try {
                    await this.deviceManagementService.setSpeakerForAudioElement(this.incomingRingingTone.audio, this.deviceManagementService.getCurrentSpeaker());
                    this.incomingRingingTone.audio.pause();
                    this.incomingRingingTone.audio.currentTime = 0;
                    this.logger.info(`[ringingService] onAudioOutputDeviceChange: startIncomingRinging main device -- play`);
                    this.incomingRingingTone.starting = true;
                    this.play(this.incomingRingingTone);
                } catch (error) { /**/ }
            }
            else {
                this.deviceManagementService.setSpeakerForAudioElement(this.incomingRingingTone.audio, this.deviceManagementService.getCurrentSpeaker());
            }
        }
    }

    private async onSecondaryAudioOutputDeviceChange() {
        if (this.settingsService.getSetting("hasSecondRinger") === "true" && this.incomingRingingSecondaryTone && this.incomingRingingSecondaryTone.audio) {
            if (!this.incomingRingingSecondaryTone.audio.paused) {
                try {
                    await this.deviceManagementService.setSpeakerForAudioElement(this.incomingRingingSecondaryTone.audio, this.deviceManagementService.getCurrentSecondaryOutputDevice());
                    this.incomingRingingSecondaryTone.audio.pause();
                    this.incomingRingingSecondaryTone.audio.currentTime = 0;
                    this.logger.info(`[ringingService] onSecondaryAudioOutputDeviceChange: startIncomingRinging secondary device -- play`);
                    this.incomingRingingSecondaryTone.starting = true;
                    this.play(this.incomingRingingSecondaryTone);
                } catch (error) { /**/ }
            }
            else {
                this.deviceManagementService.setSpeakerForAudioElement(this.incomingRingingSecondaryTone.audio, this.deviceManagementService.getCurrentSecondaryOutputDevice());
            }
        }
    }

    /*********************************************************************/
    /**                 PRIVATE FUNCTIONS                               */
    /*********************************************************************/

    private manageOnWebrtcBusy(): void { //RQRAINB-9062
        try {
            this.logger.info(`[ringingService] manageOnWebrtcBusy -- play busy tone`);
            this.stopRingBackTone();
            this.playWebrtcBusyTone();
        }
        catch (error) {
            this.logger.info(`[ringingService] manageOnWebrtcBusy -- failure -- ${error.message}`);
        }
    }

    private manageOnWebrtcRaiseHand(): void {
        try {
            this.logger.info(`[ringingService] manageOnWebrtcRaiseHand -- play raise-hand tone`);
            this.stopRingBackTone();
            this.playWebrtcRaiseHandTone();
        }
        catch (error) {
            this.logger.info(`[ringingService] manageOnWebrtcRaiseHand -- failure -- ${error.message}`);
        }
    }

    /**
     * Method setAudioCapability
     * Define type (mp3 or Ogg Vorbis) that will be used for audio files.
     * Ogg Vorbis is preferred if the current browser is able to play media of this type.
     * Otherwise mp3 is used.
     * @memberof RingingService
     * @private
     */
    private setAudioCapability(): void {
        let audio: HTMLAudioElement = new Audio();
        // Can ogg files be played ?
        const canPlayOgg: boolean = Boolean(audio.canPlayType) && Boolean(audio.canPlayType('audio/ogg; codecs="vorbis"'));
        this.logger.debug(`[ringingService] setAudioCapability -- Can play audio/ogg = ${canPlayOgg}`);
        this.audioFileType = canPlayOgg ? ".ogg" : ".mp3";
        audio = null;
    }

    private manageEmergencyNotifs(): void {
        try {
            // user can receive alertNotifications
            if (this.profileService.isFeatureEnabled(this.profileService.FeaturesEnum.ALERT_NOTIFICATIONS_ALLOWED)) {
                this.logger.debug(`[ringingService] manageEmergencyNotifs -- Emergency alarms set to default`);
                this.emergencyAlarms = ["noSound", "emergency"];
            }

            this.emergencyImSound = this.contactService.userContact.customData.emergencyImSound;
            if (!this.emergencyImSound) {
                this.emergencyImSound = this.settingsService.getSetting("emergencyImSound");
                this.logger.debug(`[ringingService] manageEmergencyNotifs -- Emergency notif sound set to ${this.emergencyImSound}`);
            }

            this.setEmergencyAlarm();
        }
        catch (error) {
            this.logger.debug(`[ringingService] manageEmergencyNotifs -- failure -- ${error.message}`);
        }
    }

    private setEmergencyAlarm(): void {
        //check at start whether the user is correctly updated
        let update = false;
        if (this.profileService.isFeatureEnabled(this.profileService.FeaturesEnum.ALERT_NOTIFICATIONS_ALLOWED) && (this.emergencyImSound === "noSound" || (this.emergencyAlarms.indexOf(this.emergencyImSound) === -1))) {
            update = true;
        }
        else if (!this.profileService.isFeatureEnabled(this.profileService.FeaturesEnum.ALERT_NOTIFICATIONS_ALLOWED) && this.emergencyAlarms.indexOf(this.emergencyImSound) === -1) {
            //check if user does not have the licence but he has an emergency notif activated
            update = true;
        }

        if (update) {
            this.emergencyImSound = this.emergencyAlarms[1];
            this.contactService.userContact.customData.emergencyImSound = this.emergencyImSound;
            this.contactService.updateUserCustomData(this.contactService.userContact.customData);
        }

        if (this.emergencyImSound !== "noSound") {
            // Main ringer device
            this.emergencyImSoundAudio = new Audio("/assets/sounds/notifs/" + this.emergencyImSound + this.audioFileType);

            // Secondary ringer device
            const hasSecondRinger: boolean = this.settingsService.getSetting("hasSecondRinger") === "true";
            if (hasSecondRinger) {
                this.emergencyImSoundAudioSecondary = new Audio("/assets/sounds/notifs/" + this.emergencyImSound + this.audioFileType);
            } else {
                this.emergencyImSoundAudioSecondary = null;
            }

            //adjust volume for emergency, as it's too loud
            if (this.presenceHelperService?.isUserCurrentlyInCall()) {
                this.emergencyImSoundAudio.volume = this.alertSoundLevelInCall;
                if (this.emergencyImSoundAudioSecondary) this.emergencyImSoundAudioSecondary.volume = this.alertSoundLevelInCall;
            }
            else {
                this.emergencyImSoundAudio.volume = this.alertSoundLevel;
                if (this.emergencyImSoundAudioSecondary) this.emergencyImSoundAudioSecondary.volume = this.alertSoundLevel + 0.2;
            }
            this.logger.debug(`[ringingService] setEmergencyAlarm -- Emergency notif sound set to ${this.emergencyImSound}`);
        }
        else {
            this.emergencyImSoundAudio = null;
            this.emergencyImSoundAudioSecondary = null;
            this.logger.info(`[ringingService] Emergency notif sound set to null`);
        }
    }

    private setActive(notif: string, alarm: string, informationImSound: string, importantImSound: string, supervisorAlarm: string, supervisorAlarmType: string, hasSecondRinger: boolean, playMessagingNotifOnSecondaryRinger: boolean): void {
        this.logger.info(`[ringingService] setActive wih notif=${notif}, alarm=${alarm}, informationImSound=${informationImSound}, importantImSound=${importantImSound}`);

        this.activeNotif = notif;
        this.activeAlarm = alarm;

        if (notif !== "noSound") {
            this.pingAudio = new Audio("/assets/sounds/notifs/" + this.activeNotif + this.audioFileType);
            this.logger.info(`[ringingService] setActive -- Notif sound set to ${this.activeNotif} for main device ${playMessagingNotifOnSecondaryRinger ? " and secondary ringer" : ""}`);
            if (hasSecondRinger && playMessagingNotifOnSecondaryRinger) {
                this.pingAudioSecondary = new Audio("/assets/sounds/notifs/" + this.activeNotif + this.audioFileType);
                this.logger.info(`[ringingService] setActive -- Notif sound set to ${this.activeNotif} for secondary ringer`);
            } else {
                this.pingAudioSecondary = null;
            }
        }
        else {
            this.pingAudio = null;
            this.pingAudioSecondary = null;
            this.logger.info(`[ringingService] setActive -- Notif sound set to null`);
        }

        if (alarm !== "noRingtone") {
            this.incomingRingingTone = { audio: new Audio(), starting: false, id: "incomingRingingTone" };
            this.incomingRingingSecondaryTone = { audio: new Audio(), starting: false, id: "incomingRingingSecondaryTone" };

            //add debug logs
            this.incomingRingingTone.audio.onloadeddata = () => { this.logger.info(`[ringingService] === incomingRingingTone -- loaded`); };
            this.incomingRingingTone.audio.oncanplay = () => { this.logger.info(`[ringingService] === incomingRingingTone -- oncanplay `); };
            this.incomingRingingTone.audio.onerror = () => {
                this.logger.error(`[ringingService] === incomingRingingTone -- onerror `);
                if (this.incomingRingingTone.audio.error) {
                    this.logger.error(`[ringingService] === incomingRingingTone -- onerror msg = ${this.incomingRingingTone.audio.error.message}`);
                }
            };

            this.incomingRingingSecondaryTone.audio.onloadeddata = () => { this.logger.info(`[ringingService] === incomingRingingSecondaryTone -- loaded`); };
            this.incomingRingingSecondaryTone.audio.oncanplay = () => { this.logger.info(`[ringingService] === incomingRingingSecondaryTone -- oncanplay `); };
            this.incomingRingingSecondaryTone.audio.onerror = () => {
                this.logger.error(`[ringingService] === incomingRingingSecondaryTone -- onerror `);
                if (this.incomingRingingSecondaryTone.audio.error) {
                    this.logger.error(`[ringingService] === incomingRingingSecondaryTone -- onerror msg = ${this.incomingRingingSecondaryTone.audio.error.message}`);
                }
            };

            // add audio sources
            this.incomingRingingTone.audio.src = "/assets/sounds/alarms/" + this.activeAlarm + this.audioFileType;
            this.incomingRingingTone.audio.preload = "auto";
            this.incomingRingingSecondaryTone.audio.preload = "auto";
            this.incomingRingingSecondaryTone.audio.src = "/assets/sounds/alarms/" + this.activeAlarm + this.audioFileType;

            this.incomingRingingTone.audio.currentTime = 0;
            this.incomingRingingTone.audio.loop = true;
            this.deviceManagementService.setSpeakerForAudioElement(this.incomingRingingTone.audio, this.deviceManagementService.getCurrentSpeaker());
            this.incomingRingingSecondaryTone.audio.currentTime = 0;
            this.incomingRingingSecondaryTone.audio.loop = true;
            this.deviceManagementService.setSpeakerForAudioElement(this.incomingRingingSecondaryTone.audio, this.deviceManagementService.getCurrentSecondaryOutputDevice());

            this.logger.info(`[ringingService] setActive -- Ringtone sound set to ${this.activeAlarm}`);
        }
        else {
            this.incomingRingingTone = null;
            this.incomingRingingSecondaryTone = null;
            this.logger.info(`[ringingService] setActive -- Ringtone sound set to null`);
        }

        if (informationImSound !== "noSound") {
            this.informationImSoundAudio = new Audio("/assets/sounds/notifs/" + informationImSound + this.audioFileType);
            this.logger.debug(`[ringingService] setActive -- Information notif sound set to ${informationImSound} for main device`);

            if (hasSecondRinger && playMessagingNotifOnSecondaryRinger) {
                this.informationImSoundAudioSecondary = new Audio("/assets/sounds/notifs/" + informationImSound + this.audioFileType);
                this.logger.info(`[ringingService] setActive -- Information notif sound set to ${informationImSound} for secondary ringer`);
            } else {
                this.informationImSoundAudioSecondary = null;
            }
        }
        else {
            this.informationImSoundAudio = null;
            this.informationImSoundAudioSecondary = null;
            this.logger.info(`[ringingService] setActive -- Information notif sound set to null`);
        }

        if (importantImSound !== "noSound") {
            this.importantImSoundAudio = new Audio("/assets/sounds/notifs/" + importantImSound + this.audioFileType);
            this.logger.debug(`[ringingService] setActive -- Important notif sound set to ${importantImSound} for main device`);

            if (hasSecondRinger && playMessagingNotifOnSecondaryRinger) {
                this.importantImSoundAudioSecondary = new Audio("/assets/sounds/notifs/" + importantImSound + this.audioFileType);
                this.logger.debug(`[ringingService] setActive -- Important notif sound set to ${importantImSound} for main device`);
            } else {
                this.importantImSoundAudioSecondary = null;
            }
        }
        else {
            this.importantImSoundAudio = null;
            this.importantImSoundAudioSecondary = null;
            this.logger.info(`[ringingService] setActive -- Important notif sound set to null`);
        }

        if (supervisorAlarm && supervisorAlarm !== "noSound" && supervisorAlarmType) {
            this.activeSupervisorRingingTone = { id: supervisorAlarm, type: supervisorAlarmType, audio: new Audio() };
            this.activeSupervisorRingingToneSecondary = { id: supervisorAlarm, type: supervisorAlarmType, audio: new Audio() };
            this.activeSupervisorRingingTone.audio.src = "/assets/sounds/" + supervisorAlarmType + "/" + supervisorAlarm + this.audioFileType;
            this.activeSupervisorRingingToneSecondary.audio.src = "/assets/sounds/" + supervisorAlarmType + "/" + supervisorAlarm + this.audioFileType;

            if (supervisorAlarmType === "alarms") {
                this.activeSupervisorRingingTone.audio.preload = "auto";
                this.activeSupervisorRingingTone.audio.currentTime = 0;
                this.activeSupervisorRingingTone.audio.loop = true;
                this.activeSupervisorRingingToneSecondary.audio.preload = "auto";
                this.activeSupervisorRingingToneSecondary.audio.currentTime = 0;
                this.activeSupervisorRingingToneSecondary.audio.loop = true;
            }
            this.logger.debug(`[ringingService] setActive -- supervisorAlarm set to ${supervisorAlarm}`);
        }
        else {
            this.activeSupervisorRingingTone = null;
            this.activeSupervisorRingingToneSecondary = null;
            this.logger.info(`[ringingService] activeSupervisorRingingTone set to null`);
        }
    }

    private shouldPlayImNotif(): boolean {
        let result = true;

        if (this.contactService.userContact.status === "busy" || this.contactService.userContact.status === "dnd") {
            result = false;
        }
        this.logger.debug(`[ringingService] shouldPlayImNotif -- result = ${result}`);

        return result;
    }

    private shouldPlaySupervisorNotif(): boolean {
        let result = true;

        if (this.contactService.userContact.status === "dnd") {
            result = false;
        }
        this.logger.debug(`[ringingService] shouldPlaySupervisorNotif -- result = ${result}`);

        return result;
    }

    /**
     * Method play
     * Play the specified audio tone
     * This function is adapted for play() method returning a Promise or not.
     * Note: The recent Audio.play() implementation in javascript does return a Promise
     * @memberof RingingService
     * @private
     * @param {any} tone Audio to play (IM notif, Audio tone ...)
     * @param {number} count  Counter used before stopping the ringing forcibly
     * @returns {void} Returns no specific value
     */
    private play(tone: any, count: number = 0): void {
        this.logger.debug(`[ringingService] play -- id = ${tone.id} - count = ${count}`);

        if (!tone?.audio) {
            this.logger.warn(`[ringingService] play tone is missing -- return`);
            return;
        }

        if (tone.stopDefered) {
            // A stop request is pending: don't try to play the tone
            this.logger.warn(`[ringingService] play tone for id ${tone.id} aborted because stop request is pending`);
            tone.starting = false;
            return;
        }

        if (tone.audio.readyState !== 4) {
            if (count < 6) {
                this.logger.warn(`[ringingService] play tone for id ${tone.id} is not ready -- retry in 500 ms`);
                setTimeout(() => {
                    count += 1;
                    this.play(tone, count);
                }, 500);
                return;
            }
            else if (tone.id === "incomingRingingTone") {
                this.logger.warn(`[ringingService] play tone for id ${tone.id}/type ${this.audioFileType} does not load .. try another type`);
                const type = (this.audioFileType === ".ogg") ? ".mp3" : ".ogg";
                this.incomingRingingTone.audio.src = "/assets/sounds/alarms/" + this.activeAlarm + type;
                this.incomingRingingTone.audio.loop = true;
                this.incomingRingingTone.audio.preload = "auto";
                this.play(this.incomingRingingTone);
                return;
            }
            else if (tone.id === "incomingRingingSecondaryTone") {
                this.logger.warn(`[ringingService] play tone for id ${tone.id}/type ${this.audioFileType} does not load .. try another type`);
                const type = (this.audioFileType === ".ogg") ? ".mp3" : ".ogg";
                this.incomingRingingSecondaryTone.audio.src = "/assets/sounds/alarms/" + this.activeAlarm + type;
                this.incomingRingingSecondaryTone.audio.loop = true;
                this.incomingRingingTone.audio.preload = "auto";
                this.play(this.incomingRingingSecondaryTone);
                return;
            }

            this.logger.warn(`[ringingService] play tone for id ${tone.id} is not ready -- try to play it anyway`);
        }

        const result = tone.audio.play();

        if (result && typeof result.finally === "function") {
            // The result is a Promise
            result.then(() => {
                this.logger.info(`[ringingService] play for id ${tone.id} ok`);
            })
                .catch((error) => {
                    this.logger.error(`[ringingService] play for id ${tone.id} error: ${error}`);
                })
                .finally(() => {
                    tone.starting = false;
                });
        } else {
            // The result is not a Promise
            this.logger.info(`[ringingService] (no promise) play for id ${tone.id} ok`);
            tone.starting = false;
        }
    }

    /**
     * Method addEvents
     * Add an event on the specified audio object (based on HTMLAudioElement)
     * @memberof RingingService
     * @private
     * @param {HTMLAudioElement} audioObject Audio resource
     * @param {any} alarm Audio infomation (name)
     */
    private addEvents(audioObject: HTMLAudioElement, alarm: any): void {
        audioObject.onended = () => {
            this.alarmNotifOnce = null;
            alarm.iconPlayer = "play";
        };
    }

    // -------------------------------------------------------------
    /// Push to Talk tones
    // -------------------------------------------------------------

    /**
     * Callback method called on reception of ON_PRESS_PUSH_TO_TALK_EVENT event
     */
    private async playActivatePtT() {

        if (this.pushToTalkActivateTone && this.contactService.userContact.customData.enablePushToTalkTone) {
            this.pushToTalkActivateTone.currentTime = 0;
            try {
                await this.deviceManagementService.setSpeakerForAudioElement(this.pushToTalkActivateTone, this.deviceManagementService.getCurrentSpeaker());
                this.logger.debug(`[ringingService] playActivatePtT -- play`);
                this.pushToTalkActivateTone.play();
            } catch (error) { /**/ }
        }
    }

    /**
     * Callback method called on reception of ON_RELEASE_PUSH_TO_TALK_EVENT event
     */
    private async playDeactivatePtT() {
        this.logger.info(`[ringingService] playDeactivatePtT`);

        if (this.pushToTalkDeactivateTone && this.contactService.userContact.customData.enablePushToTalkTone) {
            this.pushToTalkDeactivateTone.currentTime = 0;
            try {
                await this.deviceManagementService.setSpeakerForAudioElement(this.pushToTalkDeactivateTone, this.deviceManagementService.getCurrentSpeaker());
                this.logger.debug(`[ringingService] playDeactivatePtT -- play`);
                this.pushToTalkDeactivateTone.play();
            } catch (error) { /**/ }
        }
    }

    // -------------------------------------------------------------
    /// Ringback tone
    // -------------------------------------------------------------

    /**
     * Method stopRingBackToneDefered
     * Stop playing the ringback tone in a delayed way
     * @memberof RingingService
     * @private
     * @param {number} count Counter used to check if the ringing should be stopped forcibly
     */
    private stopRingBackToneDefered(count: number): void {
        this.logger.debug(`[ringingService] stopRingBackToneDefered -- count = ${count}`);

        this.ringbackTone.stopDefered = undefined;
        count += 1;
        if (count >= 3) {
            if (this.ringbackTone.audio) {
                this.logger.info(`[ringingService] stopRingBackToneDefered: tone is blocked on starting, stop it`);
                this.ringbackTone.audio.pause();
                this.ringbackTone.audio.currentTime = 0;

                //reset brutally the audio tag
                this.ringbackTone.audio.src = "";
                this.ringbackTone.audio.src = "/assets/sounds/outgoing-rings" + this.audioFileType;
                this.ringbackTone.audio.load();
            }
        }
        else {
            this.stopRingBackTone(count);
        }
    }

    // -------------------------------------------------------------
    //      Incoming Ringing
    // -------------------------------------------------------------

    /**
     * Method stopIncomingRingingDefered
     * Stop playing the Incoming Call ringing tone in a delayed way
     * @memberof RingingService
     * @private
     * @param {number} count Counter used to check if the Incoming Call ringing should be stopped forcibly
     */
    private stopIncomingRingingDefered(count: number): void {
        this.logger.debug(`[ringingService] stopIncomingRingingDefered -- count = ${count}`);

        this.incomingRingingTone.stopDefered = undefined;
        count += 1;
        if (count >= 30) {
            if (this.incomingRingingTone.audio) {
                this.logger.info(`[ringingService] stopIncomingRingingDefered: tone is blocked on starting, stop it`);
                this.incomingRingingTone.audio.pause();

                //reset brutally the audio tag
                this.incomingRingingTone.audio.src = "";
                this.incomingRingingTone.audio.src = "/assets/sounds/alarms/" + this.activeAlarm + this.audioFileType;
                this.incomingRingingTone.audio.currentTime = 0;
                this.incomingRingingTone.audio.loop = true;
                this.incomingRingingTone.audio.load();
            }
        }
        else {
            this.stopIncomingRinging(count);
        }
    }

    /**
     * Method stopIncomingRingingSecondaryDefered
     * Stop playing the Incoming Call ringing tone on secondary device in a delayed way
     * @memberof RingingService
     * @private
     * @param {number} count Counter used to check if the Incoming Call ringing should be stopped forcibly
     */
    private stopIncomingRingingSecondaryDefered(count: number): void {
        this.logger.debug(`[ringingService] stopIncomingRingingSecondaryDefered -- count = ${count}`);

        this.incomingRingingSecondaryTone.stopDefered = undefined;
        count += 1;
        if (count >= 30) {
            if (this.incomingRingingSecondaryTone.audio) {
                this.logger.info(`[ringingService] stopIncomingRingingSecondaryDefered: tone is blocked on starting, stop it`);
                this.incomingRingingSecondaryTone.audio.pause();

                //reset brutally the audio tag
                this.incomingRingingSecondaryTone.audio.src = "";
                this.incomingRingingSecondaryTone.audio.src = "/assets/sounds/alarms/" + this.activeAlarm + this.audioFileType;
                this.incomingRingingSecondaryTone.audio.currentTime = 0;
                this.incomingRingingSecondaryTone.audio.loop = true;
                this.incomingRingingSecondaryTone.audio.load();
            }
        }
        else {
            this.stopIncomingRinging(count);
        }
    }

    // -------------------------------------------------------------
    //      Secondary call incoming tone
    // -------------------------------------------------------------

    /**
     * Method stopSecondToneDefered
     * Stop playing the secondary call incoming tone in a delayed way
     * @memberof RingingService
     * @private
     */
    private stopSecondToneDefered(): void {
        this.logger.debug(`[ringingService] stopSecondToneDefered`);

        this.secondCallTone.stopDefered = undefined;
        this.stopSecondCallTone();
    }

    // -------------------------------------------------------------
    //      Web conference tone
    // -------------------------------------------------------------

    /**
     * Method stopHoldToneDefered
     * Stop playing the Web conference tonein a delayed way
     * @memberof RingingService
     * @private
     */
    private stopHoldToneDefered(): void {
        this.logger.debug(`[ringingService] stopHoldToneDefered`);

        this.holdTone.stopDefered = undefined;
        this.stopHoldTone();
    }

    /*********************************************************************/
    /**                 PUBLIC FUNCTIONS                                */
    /*********************************************************************/

    /**
     * Method getAudioFileType
     * Returns type (mp3 or Ogg Vorbis) that will be used for audio files.
     * @memberof RingingService
     * @private
     * @returns {string} Returns type (mp3 or Ogg Vorbis) that will be used for audio files.
     */
    public getAudioFileType(): string {
        return this.audioFileType;
    }

    /**
     * Method playWebConferenceJoinNotif
     * Play a tone when a participant has joined a Web conference
     * Callback method called on reception of ON_WEB_CONFENRECE_PARTICIPANT_JOINED_EVENT event
     * @memberof RingingService
     * @private
     * @param {Event} __event Native event
     * @param {any} confSession Web Conference Session
     */
    public async playWebConferenceJoinNotif(__event: Event, confSession: any) {
        let room = null;
        if (confSession) {
            room = this.roomService.getBubbleFromCache(confSession.id);
            if (!room) {
                room = this.roomService.getBubbleFromCache(confSession.roomId);
            }
        }
        if (this.joinWebConfTone && room && room.getSettings().playEntryTone) {
            this.logger.info(`[ringingService] playWebConferenceJoinNotif`);
            this.joinWebConfTone.currentTime = 0;
            try {
                await this.deviceManagementService.setSpeakerForAudioElement(this.joinWebConfTone, this.deviceManagementService.getCurrentSpeaker());
                this.joinWebConfTone.play();
            } catch (error) { /**/ }
        }
    }

    /**
     * Method playWebrtcBusyTone
     * Play a busy tone when a webrtc outgoing call is rejected because called is busy
     * @memberof RingingService
     * @private
     */
    public async playWebrtcBusyTone() {

        if (this.webrtcBusyTone) {
            this.logger.info(`[ringingService] playWebrtcBusyTone`);
            this.webrtcBusyTone.currentTime = 0;
            try {
                await this.deviceManagementService.setSpeakerForAudioElement(this.webrtcBusyTone, this.deviceManagementService.getCurrentSpeaker());
                this.webrtcBusyTone.play();
            } catch (error) { /**/ }
        }
    }

    /**
     * Method playWebrtcRaiseHandTone
     * Play a tone when someone raises their hand in a conference (excluding me)
     * @memberof RingingService
     * @private
     */
    public async playWebrtcRaiseHandTone() {

        if (this.webrtcRaiseHandTone) {
            this.logger.info(`[ringingService] playWebrtcRaiseHandTone`);
            this.webrtcRaiseHandTone.currentTime = 0;
            try {
                await this.deviceManagementService.setSpeakerForAudioElement(this.webrtcRaiseHandTone, this.deviceManagementService.getCurrentSpeaker());
                this.webrtcRaiseHandTone.play();
            } catch (error) { /**/ }
        }
    }

    /**
     * Method setActiveAlarm
     * Set the specified alarm as active
     * @memberof RingingService
     * @private
     * @param {any} alarm Name of the alarm to set as active, one of defined in 'alarms' array
     */
    public setActiveAlarm(alarm: any): void {
        this.logger.info(`[ringingService] setActiveAlarm to ${alarm}`);

        this.activeAlarm = alarm;
        this.contactService.setUserSettings({ activeAlarm: this.activeAlarm });

        if (alarm !== "noRingtone") {
            this.incomingRingingTone = { audio: new Audio(), starting: false, id: "incomingRingingTone" };
            this.incomingRingingSecondaryTone = { audio: new Audio("/assets/sounds/alarms/" + this.activeAlarm + this.audioFileType), starting: false, id: "incomingRingingSecondaryTone" };

            //debug stuff
            this.incomingRingingTone.audio.onloadeddata = () => { this.logger.info(`[ringingService] === incomingRingingTone -- loaded`); };
            this.incomingRingingTone.audio.oncanplay = () => { this.logger.info(`[ringingService] === incomingRingingTone -- oncanplay `); };
            this.incomingRingingTone.audio.onerror = () => {
                this.logger.error(`[ringingService] === incomingRingingTone -- onerror `);
                if (this.incomingRingingTone.audio.error) {
                    this.logger.error(`[ringingService] === incomingRingingTone -- onerror msg = ${this.incomingRingingTone.audio.error.message}`);
                }
            };
            this.incomingRingingTone.audio.preload = "auto";
            this.incomingRingingTone.audio.src = "/assets/sounds/alarms/" + this.activeAlarm + this.audioFileType;
            this.incomingRingingTone.audio.currentTime = 0;
            this.incomingRingingTone.audio.loop = true;
            this.incomingRingingTone.audio.load();

            this.incomingRingingSecondaryTone.audio.preload = "auto";
            this.incomingRingingSecondaryTone.audio.currentTime = 0;
            this.incomingRingingSecondaryTone.audio.loop = true;

            this.deviceManagementService.setSpeakerForAudioElement(this.incomingRingingTone.audio, this.deviceManagementService.getCurrentSpeaker());
            this.deviceManagementService.setSpeakerForAudioElement(this.incomingRingingSecondaryTone.audio, this.deviceManagementService.getCurrentSecondaryOutputDevice());
        }
        else {
            this.incomingRingingTone = null;
            this.incomingRingingSecondaryTone = null;
            this.logger.info(`[ringingService] setActiveAlarm -- Ringtone sound set to null`);
        }
    }

    /**
     * Method setActiveAlarm
     * Activate and configure the secondary ringer
     * @memberof RingingService
     * @private
     */
    public activateSecondaryRinger(): void {
        this.logger.info(`[ringingService] activateSecondaryRinger`);

        this.incomingRingingSecondaryTone = { audio: new Audio("/assets/sounds/alarms/" + this.activeAlarm + this.audioFileType), starting: false, id: "incomingRingingSecondaryTone" };
        this.incomingRingingSecondaryTone.audio.preload = "auto";
        this.incomingRingingSecondaryTone.audio.currentTime = 0;
        this.incomingRingingSecondaryTone.audio.loop = true;
        this.deviceManagementService.setSpeakerForAudioElement(this.incomingRingingSecondaryTone.audio, this.deviceManagementService.getCurrentSecondaryOutputDevice());
    }

    public changePlayMessagingNotifOnSecondaryRinger(playMessagingNotifOnSecondaryRinger: boolean): void {
        this.logger.info(`[ringingService] changePlayMessagingNotifOnSecondaryRinger ${playMessagingNotifOnSecondaryRinger}`);

        if (this.activeNotif !== "noSound" && playMessagingNotifOnSecondaryRinger) {
            this.pingAudioSecondary = new Audio("/assets/sounds/notifs/" + this.activeNotif + this.audioFileType);
            this.logger.info(`[ringingService] changePlayMessagingNotifOnSecondaryRinger -- Notif sound ${this.activeNotif} activated on secondary ringer`);
        } else {
            this.pingAudioSecondary = null;
            this.logger.info(`[ringingService] changePlayMessagingNotifOnSecondaryRinger -- Notif sound cancelled on secondary ringer`);
        }

        if (this.informationImSound !== "noSound" && playMessagingNotifOnSecondaryRinger) {
            this.informationImSoundAudioSecondary = new Audio("/assets/sounds/notifs/" + this.informationImSound + this.audioFileType);
            this.logger.info(`[ringingService] changePlayMessagingNotifOnSecondaryRinger -- Information Notif sound ${this.informationImSound} activated on secondary ringer`);
        } else {
            this.informationImSoundAudioSecondary = null;
            this.logger.info(`[ringingService] changePlayMessagingNotifOnSecondaryRinger -- Information Notif sound cancelled on secondary ringer`);
        }

        if (this.importantImSound !== "noSound" && playMessagingNotifOnSecondaryRinger) {
            this.importantImSoundAudioSecondary = new Audio("/assets/sounds/notifs/" + this.importantImSound + this.audioFileType);
            this.logger.info(`[ringingService] changePlayMessagingNotifOnSecondaryRinger -- Important Notif sound ${this.importantImSound} activated on secondary ringer`);
        } else {
            this.importantImSoundAudioSecondary = null;
            this.logger.info(`[ringingService] changePlayMessagingNotifOnSecondaryRinger -- Important Notif sound cancelled on secondary ringer`);
        }
    }

    /**
     * Method playAlarmOnce
     * Play once the specified alarm
     * @memberof RingingService
     * @private
     * @param {any} alarm Name of the alarm to play, one of defined in 'alarms' array
     */
    public playAlarmOnce(alarm: any): void {
        this.logger.info(`[ringingService] playAlarmOnce ${alarm.name}`);

        if (this.alarmNotifOnce !== null) { this.alarmNotifOnce.pause(); }
        this.alarmNotifOnce = new Audio("/assets/sounds/alarms/" + alarm.name + this.audioFileType);
        this.alarmNotifOnce.currentTime = 0;
        this.alarmNotifOnce.play();
        this.addEvents(this.alarmNotifOnce, alarm);
    }

    /**
     * Method stopAlarmOnce
     * stop the alarm that asked to be played only once
     * @memberof RingingService
     * @private
     */
    public stopAlarmOnce(): void {
        this.logger.info(`[ringingService] stopAlarmOnce`);
        if (this.alarmNotifOnce) {
            this.alarmNotifOnce.pause();
            this.alarmNotifOnce = null;
        }
    }

    /**
     * Method alarmCurPlay
     * Check if the alarm that asked to be played only once is currently playing
     * @memberof RingingService
     * @private
     * @returns {boolean} Returns true
     */
    private alarmCurPlay(): boolean {
        return this.alarmNotifOnce instanceof Audio;
    }

    /**
     * Method setActiveNotif
     * Set the specified notification (for example, for chat) as active
     * @memberof RingingService
     * @private
     * @param {any} notif Name of the notification to set as active, one of defined in 'notifs' array
     */
    public setActiveNotif(notif: any): void {
        this.logger.info(`[ringingService] setActiveNotif to ${notif}`);

        this.activeNotif = notif;
        this.contactService.setUserSettings({ activeNotif: this.activeNotif });
        if (notif !== "noSound") {
            // Main ringer device
            this.pingAudio = new Audio("/assets/sounds/notifs/" + this.activeNotif + this.audioFileType);
            this.logger.info(`[ringingService] setActiveNotif -- Notif sound set to ${this.activeNotif} for main device`);

            // Secondary ringer device
            const hasSecondRinger: boolean = this.settingsService.getSetting("hasSecondRinger") === "true";
            const playMessagingNotifOnSecondaryRinger: boolean = this.settingsService.getSetting("playMessagingNotifOnSecondaryRinger") === "true";
            if (hasSecondRinger && playMessagingNotifOnSecondaryRinger) {
                this.pingAudioSecondary = new Audio("/assets/sounds/notifs/" + this.activeNotif + this.audioFileType);
                this.logger.info(`[ringingService] setActiveNotif -- Notif sound set to ${this.activeNotif} for secondary ringer`);
            } else {
                this.pingAudioSecondary = null;
            }
        }
        else {
            this.pingAudio = null;
            this.pingAudioSecondary = null;
            this.logger.info(`[ringingService] Notif sound set to null`);
        }
    }

    /**
     * Method playNotifOnce
     * Play once the specified notification
     * @memberof RingingService
     * @private
     * @param {any} notif Name of the notification to play, one of defined in 'notifs' array
     */
    public playNotifOnce(notif: any): void {
        this.logger.info(`[ringingService] playNotifOnce ${notif.name}`);

        this.audioNotifOnce = new Audio("/assets/sounds/notifs/" + notif.name + this.audioFileType);
        this.audioNotifOnce.currentTime = 0;
        this.audioNotifOnce.play();
        this.addEvents(this.audioNotifOnce, notif);
    }

    /**
     * Method stopNotifOnce
     * stop the notification that asked to be played only once
     * @memberof RingingService
     * @private
     */
    public stopNotifOnce(): void {
        this.logger.info(`[ringingService] stopNotifOnce`);
        this.audioNotifOnce.pause();
        this.audioNotifOnce = null;
    }

    /**
     * Method notifCurPlay
     * Check if the notification that asked to be played only once is currently playing
     * @memberof RingingService
     * @private
     * @returns {boolean} Returns true
     */
    private notifCurPlay(): boolean {
        return this.audioNotifOnce instanceof Audio;
    }

    /**
     * Method setInformationImSound
     * Set the sound for notification regarding information IM
     * @memberof RingingService
     * @private
     * @param {any} notif Set Name of the sound to play as notification for information IM, one of defined in 'notifs' array
     */
    public setInformationImSound(notif: any): void {
        this.logger.info(`[ringingService] setInformationImSound to ${notif}`);

        this.informationImSound = notif;
        this.settingsService.setSetting("informationImSound", notif);
        this.contactService.userContact.customData.informationImSound = notif;
        this.contactService.updateUserCustomData(this.contactService.userContact.customData);

        if (notif !== "noSound") {
            // Main ringer device
            this.informationImSoundAudio = new Audio("/assets/sounds/notifs/" + this.informationImSound + this.audioFileType);
            this.logger.info(`[ringingService] setInformationImSound -- Information Notif sound set to ${this.informationImSound} for main device`);

            // Secondary ringer device
            const hasSecondRinger: boolean = this.settingsService.getSetting("hasSecondRinger") === "true";
            const playMessagingNotifOnSecondaryRinger: boolean = this.settingsService.getSetting("playMessagingNotifOnSecondaryRinger") === "true";
            if (hasSecondRinger && playMessagingNotifOnSecondaryRinger) {
                this.informationImSoundAudioSecondary = new Audio("/assets/sounds/notifs/" + this.informationImSound + this.audioFileType);
                this.logger.info(`[ringingService] setInformationImSound -- Information Notif sound set to ${this.informationImSound} for secondary ringer`);
            } else {
                this.informationImSoundAudioSecondary = null;
            }
        }
        else {
            this.informationImSoundAudio = null;
            this.informationImSoundAudioSecondary = null;
            this.logger.debug(`[ringingService] Information sound set to null`);
        }
    }

    /**
     * Method setImportantImSound
     * Set the sound for notification regarding important IM
     * @memberof RingingService
     * @private
     * @param {any} notif Name of the sound to play as notification for important IM, one of defined in 'notifs' array
     */
    public setImportantImSound(notif: any): void {
        this.logger.info(`[ringingService] setImportantImSound to ${notif}`);

        this.importantImSound = notif;
        this.settingsService.setSetting("importantImSound", notif);
        this.contactService.userContact.customData.importantImSound = notif;
        this.contactService.updateUserCustomData(this.contactService.userContact.customData);

        if (notif !== "noSound") {
            // Main ringer device
            this.importantImSoundAudio = new Audio("/assets/sounds/notifs/" + this.importantImSound + this.audioFileType);
            this.logger.info(`[ringingService] setImportantImSound -- Important Notif sound set to ${this.importantImSound} for main device`);

            // Secondary ringer device
            const hasSecondRinger: boolean = this.settingsService.getSetting("hasSecondRinger") === "true";
            const playMessagingNotifOnSecondaryRinger: boolean = this.settingsService.getSetting("playMessagingNotifOnSecondaryRinger") === "true";
            if (hasSecondRinger && playMessagingNotifOnSecondaryRinger) {
                this.importantImSoundAudioSecondary = new Audio("/assets/sounds/notifs/" + this.importantImSound + this.audioFileType);
                this.logger.info(`[ringingService] setImportantImSound -- Important Notif sound set to ${this.importantImSound} for secondary ringer`);
            } else {
                this.importantImSoundAudioSecondary = null;
            }
        }
        else {
            this.importantImSoundAudio = null;
            this.importantImSoundAudioSecondary = null;
            this.logger.debug(`[ringingService] Important sound set to null`);
        }
    }

    /**
     * Method setEmergencyImSound
     * Set the sound for notification regarding emergency IM
     * @memberof RingingService
     * @private
     * @param {any} notif Name of the sound to play as notification for emergency IM, one of defined in 'notifs' array
     */
    public setEmergencyImSound(notif: any): void {
        this.logger.info(`[ringingService] setEmergencyImSound to ${notif}`);

        this.emergencyImSound = notif;
        this.settingsService.setSetting("emergencyImSound", notif);
        this.contactService.userContact.customData.emergencyImSound = notif;
        this.contactService.updateUserCustomData(this.contactService.userContact.customData);

        if (notif !== "noSound") {
            // Main ringer device
            this.emergencyImSoundAudio = new Audio("/assets/sounds/notifs/" + this.emergencyImSound + this.audioFileType);

            // Secondary ringer device
            const hasSecondRinger: boolean = this.settingsService.getSetting("hasSecondRinger") === "true";
            if (hasSecondRinger) {
                this.emergencyImSoundAudioSecondary = new Audio("/assets/sounds/notifs/" + this.emergencyImSound + this.audioFileType);
            } else {
                this.emergencyImSoundAudioSecondary = null;
            }
            //adjust volume for emergency, as it's too loud
            if (this.presenceHelperService?.isUserCurrentlyInCall()) {
                this.emergencyImSoundAudio.volume = this.alertSoundLevelInCall;
                if (this.emergencyImSoundAudioSecondary) this.emergencyImSoundAudioSecondary.volume = this.alertSoundLevelInCall;
            }
            else {
                this.emergencyImSoundAudio.volume = this.alertSoundLevel;
                if (this.emergencyImSoundAudioSecondary) this.emergencyImSoundAudioSecondary.volume = this.alertSoundLevel + 0.2;
            }
        }
        else {
            this.emergencyImSoundAudio = null;
            this.emergencyImSoundAudioSecondary = null;
            this.logger.debug(`[ringingService] Emergency sound set to null`);
        }
    }

    /**
     * Method stopUrgencyNotif
     * stop the sound played as notification for emergency IM
     * @memberof RingingService
     * @private
     */
    public stopUrgencyNotif(): void {
        this.logger.info(`[ringingService] stopUrgencyNotif`);
        if (this.emergencyImSoundAudio) {
            this.emergencyImSoundAudio.pause();
            this.emergencyImSoundAudio = null;
        }
        if (this.emergencyImSoundAudioSecondary) {
            this.emergencyImSoundAudioSecondary.pause();
            this.emergencyImSoundAudioSecondary = null;
        }
    }

    /**
     * Method playCustomNotif
     * Play the specified custom notification
     * @memberof RingingService
     * @private
     * @param {string} typeNotif Type of notification to play
     */
    public async playCustomNotif(typeNotif: string) {
        this.logger.info(`[ringingService] playCustomNotif -- typeNotif = ${typeNotif}`);

        if (this.stopWebrtcSounds) {
            this.logger.info(`[ringingService] playCustomNotif -- playImNotif is blocked...`);
            return;
        }

        if (typeNotif === NotificationType.NOTIFICATIONTYPE_STANDARD
            || (typeNotif === NotificationType.NOTIFICATIONTYPE_HIGH && !this.contactService.userContact.alertNotificationEnabledForMyCompany)) {
            this.playImNotif();
            return;
        }

        if ((typeNotif === NotificationType.NOTIFICATIONTYPE_LOW || typeNotif === NotificationType.NOTIFICATIONTYPE_MIDDLE)
            && !this.shouldPlayImNotif()) {
            this.logger.info(`[ringingService] playCustomNotif  -- ignored`);
            return;
        }

        let imSoundAudio: any;
        let imSoundAudioSecondary: any;

        switch (typeNotif) {
            case NotificationType.NOTIFICATIONTYPE_LOW:
                imSoundAudio = this.informationImSoundAudio;
                imSoundAudioSecondary = this.informationImSoundAudioSecondary;
                break;

            case NotificationType.NOTIFICATIONTYPE_MIDDLE:
                imSoundAudio = this.importantImSoundAudio;
                imSoundAudioSecondary = this.importantImSoundAudioSecondary;
                break;

            case NotificationType.NOTIFICATIONTYPE_HIGH:
                if (this.emergencyImSoundAudio) { this.emergencyImSoundAudio.pause(); }
                this.emergencyImSoundAudio = new Audio("/assets/sounds/notifs/" + this.emergencyImSound + this.audioFileType);
                this.emergencyImSoundAudio.currentTime = 0;
                if (this.profileService.isFeatureEnabled(this.profileService.FeaturesEnum.ALERT_NOTIFICATIONS_ALLOWED)) {
                    this.emergencyImSoundAudio.loop = true;
                }
                if (this.emergencyImSoundAudioSecondary) { this.emergencyImSoundAudioSecondary.pause(); }
                if (this.settingsService.getSetting("hasSecondRinger") === "true") {
                    this.emergencyImSoundAudioSecondary = new Audio("/assets/sounds/notifs/" + this.emergencyImSound + this.audioFileType);
                    this.emergencyImSoundAudioSecondary.currentTime = 0;
                    if (this.profileService.isFeatureEnabled(this.profileService.FeaturesEnum.ALERT_NOTIFICATIONS_ALLOWED)) {
                        this.emergencyImSoundAudioSecondary.loop = true;
                    }
                }

                //adjust volume for emergency, as it's too loud
                //check if user is currently in call
                if (this.presenceHelperService?.isUserCurrentlyInCall()) {
                    this.emergencyImSoundAudio.volume = this.alertSoundLevelInCall;
                    if (this.emergencyImSoundAudioSecondary) this.emergencyImSoundAudioSecondary.volume = this.alertSoundLevelInCall;
                }
                else {
                    this.emergencyImSoundAudio.volume = this.alertSoundLevel;
                    if (this.emergencyImSoundAudioSecondary) this.emergencyImSoundAudioSecondary.volume = this.alertSoundLevel + 0.2;
                }

                imSoundAudio = this.emergencyImSoundAudio;
                imSoundAudioSecondary = this.emergencyImSoundAudioSecondary;
                break;

            default:
                this.playImNotif();
                return;
        }

        if (imSoundAudioSecondary && this.settingsService.getSetting("hasSecondRinger") === "true") {
            try {
                await this.deviceManagementService.setSpeakerForAudioElement(imSoundAudioSecondary, this.deviceManagementService.getCurrentSecondaryOutputDevice());
                imSoundAudioSecondary.play();
            } catch (error) { /**/ }
        }

        if (imSoundAudio) {
            try {
                await this.deviceManagementService.setSpeakerForAudioElement(imSoundAudio, this.deviceManagementService.getCurrentSpeaker());
                imSoundAudio.play();
            } catch (error) { /**/ }
        }
    }

    // -------------------------------------------------------------
    //      Ringback tone
    // -------------------------------------------------------------

    /**
     * Method startRingBackTone
     * Start playing the ringback tone
     * @memberof RingingService
     * @private
     * @param {boolean} isWebrtcCall True if we are in a WebRTC call usecase
     */
    public async startRingBackTone(isWebrtcCall: boolean) {
        if (isWebrtcCall && this.stopWebrtcSounds) {
            this.logger.info(`[ringingService] startRingBackTone is blocked for webrtc calls...`);
            return;
        }

        if (this.ringbackTone?.stopDefered) {
            // cancel defered stop operation
            this.logger.info(`[ringingService] startRingBackTone: cancel defered stop operation`);
            clearTimeout(this.ringbackTone.stopDefered);
            this.ringbackTone.stopDefered = undefined;
        }
        if (this.ringbackTone?.audio?.paused && !this.ringbackTone.starting) {
            this.logger.info(`[ringingService] startRingBackTone currently paused`);
            this.ringbackTone.starting = true;
            try {
                await this.deviceManagementService.setSpeakerForAudioElement(this.ringbackTone.audio, this.deviceManagementService.getCurrentSpeaker());
                this.play(this.ringbackTone);
            } catch (error) { /**/ }
        } else {
            this.logger.info(`[ringingService] startRingBackTone -- nothing to do (already starting or playing)`);
        }
    }

    /**
     * Method stopRingBackTone
     * Stop playing the ringback tone
     * @memberof RingingService
     * @private
     * @param {number} count Counter used to stop forcibly the ringback tone
     */
    public stopRingBackTone(count: number = 1): void {
        this.logger.debug(`[ringingService] stopRingBackTone -- count = ${count}`);

        if (this.ringbackTone) {
            //if we're still starting the ring-back-tone, try to stop it in a sec
            if (this.ringbackTone.starting) {
                if (!this.ringbackTone.stopDefered) {
                    this.logger.debug(`[ringingService] stopRingBackTone: tone still starting: defer stop 1s later`);
                    this.ringbackTone.stopDefered = setTimeout(() => { this.stopRingBackToneDefered(count); }, 1000);

                } else {
                    this.logger.debug(`[ringingService] stopRingBackTone: nothing to do : stop already defered`);
                }
                return;
            }

            //audio is not starting anymore: stop it, if it's playing
            this.ringbackTone.stopDefered = undefined;
            if (this.ringbackTone.audio && !this.ringbackTone.audio.paused) {
                this.logger.info(`[ringingService] stopRingBackTone: tone is playing: stop it`);
                this.ringbackTone.audio.pause();
                this.ringbackTone.audio.currentTime = 0;
                this.ringbackTone.audio.load();
            } else {
                this.logger.debug(`[ringingService] stopRingBackTone: nothing to do : tone is already stopped`);
            }
        }
    }

    // -------------------------------------------------------------
    //      Incoming Ringing
    // -------------------------------------------------------------
    /**
     * Method startIncomingRinging
     * Start playing the Incoming Call ringing tone
     * @memberof RingingService
     * @private
     * @param {boolean} isWebrtcCall True if we are in a WebRTC call usecase
     */
    public async startIncomingRinging(isWebrtcCall: boolean = false) {
        if (isWebrtcCall && this.stopWebrtcSounds) {
            this.logger.info(`[ringingService] startIncomingRinging is blocked for webrtc calls...`);
            return;
        }

        this.logger.info(`[ringingService] startIncomingRinging -- Request already in progress = ${this.isStartIncomingRingingRequest}`);

        if (this.incomingRingingTone?.stopDefered) {
            //cancel defered stop operation
            this.logger.info(`[ringingService] startIncomingRinging: cancel defered stop operation`);
            clearTimeout(this.incomingRingingTone.stopDefered);
            this.incomingRingingTone.stopDefered = undefined;
        }

        if (!this.isStartIncomingRingingRequest && ((this.incomingRingingTone?.audio) || (this.incomingRingingSecondaryTone?.audio))) {
            this.logger.info(`[ringingService] startIncomingRinging currently paused`);

            this.isStartIncomingRingingRequest = true;

            if (this.settingsService.getSetting("hasSecondRinger") === "true") {
                this.incomingRingingSecondaryTone.starting = true;
                try {
                    // await this.deviceManagementService.setSpeakerForAudioElement(this.incomingRingingSecondaryTone.audio, this.deviceManagementService.getCurrentSecondaryOutputDevice());
                    this.logger.info(`[ringingService] startIncomingRinging secondary device -- play`);
                    this.play(this.incomingRingingSecondaryTone);
                } catch (error) { /**/ }
            }

            const playOnSecondaryDeviceOnly: boolean = (this.settingsService.getSetting("hasSecondRinger") === "true") && (this.settingsService.getSetting("toneOnSecondaryRingerOnly") === "true");

            if (!playOnSecondaryDeviceOnly) {
                try {
                    this.incomingRingingTone.starting = true;
                    // await this.deviceManagementService.setSpeakerForAudioElement(this.incomingRingingTone.audio, this.deviceManagementService.getCurrentSpeaker());
                    this.logger.info(`[ringingService] startIncomingRinging main device -- play`);
                    this.play(this.incomingRingingTone);
                } catch (error) { /**/ }
            }
        } else {
            this.logger.info(`[ringingService] startIncomingRinging -- nothing to do (already starting or playing)`);
        }
    }

    /**
     * Method stopIncomingRinging
     * Stop playing the Incoming Call ringing tone
     * @memberof RingingService
     * @private
     * @param {number} count Counter used to stop forcibly the Incoming Call ringing tone
     */
    public stopIncomingRinging(count: number = 1): void {
        this.logger.debug(`[ringingService] stopIncomingRinging -- count = ${count}`);

        // Cancels the fact that a 'StartIncomingRingin' request is in process
        this.isStartIncomingRingingRequest = false;

        if (this.incomingRingingTone) {
            //if we're still starting the incoming ringing tone, try to stop it in after 1 sec
            if (this.incomingRingingTone.starting) {
                if (!this.incomingRingingTone.stopDefered) {
                    this.logger.debug(`[ringingService] stopIncomingRinging: tone still starting: defer stop 1s later`);
                    this.incomingRingingTone.stopDefered = setTimeout(() => { this.stopIncomingRingingDefered(count); }, 1000);
                } else {
                    this.logger.debug(`[ringingService] stopIncomingRinging: nothing to do : stop already defered`);
                }
                return;
            }
            //audio is not starting anymore: stop it, if it's playing
            this.incomingRingingTone.stopDefered = undefined;
            if (this.incomingRingingTone.audio && !this.incomingRingingTone.audio.paused) {
                this.logger.info(`[ringingService] stopIncomingRinging: tone is playing: stop it`);
                this.incomingRingingTone.audio.pause();
                this.incomingRingingTone.audio.currentTime = 0;
            } else {
                this.logger.debug(`[ringingService] stopIncomingRinging: nothing to do : tone is already stopped`);
            }
        }

        if (this.incomingRingingSecondaryTone) {
            //if we're still starting the incoming ringing tone, try to stop it in after 1 sec
            if (this.incomingRingingSecondaryTone.starting) {
                if (!this.incomingRingingSecondaryTone.stopDefered) {
                    this.logger.debug(`[ringingService] stopIncomingRinging: secondary tone still starting: defer stop 1s later`);
                    this.incomingRingingSecondaryTone.stopDefered = setTimeout(() => { this.stopIncomingRingingSecondaryDefered(count); }, 1000);
                } else {
                    this.logger.debug(`[ringingService] stopIncomingRinging: nothing to do : secondary stop already defered`);
                }
                return;
            }

            // audio is not starting anymore: stop it, if it's playing
            this.incomingRingingSecondaryTone.stopDefered = undefined;
            if (this.incomingRingingSecondaryTone.audio && !this.incomingRingingSecondaryTone.audio.paused) {
                this.logger.info(`[ringingService] stopIncomingRinging: secondary tone is playing: stop it`);
                this.incomingRingingSecondaryTone.audio.pause();
                this.incomingRingingSecondaryTone.audio.currentTime = 0;
            } else {
                this.logger.debug(`[ringingService] stopIncomingRinging: nothing to do : secondary tone is already stopped`);
            }
        }
    }

    // -------------------------------------------------------------
    //      Secondary call incoming tone
    // -------------------------------------------------------------

    /**
     * Method playSecondCallTone
     * Start playing the secondary call incoming tone
     * @memberof RingingService
     * @private
     */
    public async playSecondCallTone() {
        if (this.settingsService.getBooleanSetting("disableWaitingCallTone")) {
            this.logger.info(`[ringingService] playSecondCallTone -- disableWaitingCallTone is TRUE, user has disabled second ringing`);
            return;
        }

        this.logger.info(`[ringingService] playSecondCallTone...`);
        if (this.secondCallTone?.audio) {
            if (this.secondCallTone?.stopDefered) {
                //cancel defered stop operation
                this.logger.info(`[ringingService] playSecondCallTone: cancel defered stop operation`);
                clearTimeout(this.secondCallTone.stopDefered);
                this.secondCallTone.stopDefered = undefined;
            }
            if (this.secondCallTone?.audio?.paused && !this.secondCallTone.starting) {
                this.secondCallTone.starting = true;
                this.secondCallTone.audio.currentTime = 0;
                this.secondCallTone.audio.volume = 0.5;

                try {
                    await this.deviceManagementService.setSpeakerForAudioElement(this.secondCallTone.audio, this.deviceManagementService.getCurrentSpeaker());
                    this.logger.info(`[ringingService] playSecondCallTone play`);
                    this.play(this.secondCallTone);
                } catch (error) { /**/ }
            } else {
                this.logger.info(`[ringingService] playSecondCallTone -- nothing to do (already starting or playing)`);
            }
        }
        else {
            this.logger.info(`[ringingService] playSecondCallTone -- ignored as settings is disabled`);
        }
    }

    /**
     * Method stopSecondCallTone
     * Stop playing the secondary call incoming tone
     * @memberof RingingService
     * @private
     */
    public stopSecondCallTone(): void {
        this.logger.debug(`[ringingService] stopSecondCallTone`);

        if (this.secondCallTone) {
            //if we're still starting the holdtone, try to stop it in a sec
            if (this.secondCallTone.starting) {
                if (!this.secondCallTone.stopDefered) {
                    this.logger.debug(`[ringingService] stopSecondCallTone: tone still starting: defer stop 1s later`);
                    this.secondCallTone.stopDefered = setTimeout(() => { this.stopSecondToneDefered(); }, 1000);
                } else {
                    this.logger.debug(`[ringingService] stopSecondCallTone: nothing to do : stop already defered`);
                }
                return;
            }

            //audio is not starting anymore: stop it, if it's playing
            this.secondCallTone.stopDefered = undefined;
            if (this.secondCallTone.audio && !this.secondCallTone.audio.paused) {
                this.logger.info(`[ringingService] stopSecondCallTone: tone is playing: stop it`);
                this.secondCallTone.audio.pause();
                this.secondCallTone.audio.currentTime = 0;
            } else {
                this.logger.debug(`[ringingService] stopSecondCallTone: nothing to do : tone is already stopped`);
            }
        }
    }

    // -------------------------------------------------------------
    //      Put On Hold tone
    // -------------------------------------------------------------

    /**
     * Method playHoldTone
     * Start playing the Put On Hold tone
     * @memberof RingingService
     * @private
     */
    public async playHoldTone() {
        this.logger.info(`[ringingService] playHoldTone...`);
        if (this.holdTone?.stopDefered) {
            //cancel defered stop operation
            this.logger.info(`[ringingService] playHoldTone: cancel defered stop operation`);
            clearTimeout(this.holdTone.stopDefered);
            this.holdTone.stopDefered = undefined;
        }
        if (this.holdTone?.audio?.paused && !this.holdTone.starting) {
            this.holdTone.starting = true;
            this.holdTone.audio.currentTime = 0;

            try {
                await this.deviceManagementService.setSpeakerForAudioElement(this.holdTone.audio, this.deviceManagementService.getCurrentSpeaker());
                this.logger.info(`[ringingService] playHoldTone play`);
                this.play(this.holdTone);
            } catch (error) { /**/ }

        } else {
            this.logger.info(`[ringingService] playHoldTone -- nothing to do (already starting or playing)`);
        }
    }

    /**
     * Method stopHoldTone
     * Stop playing the Put On Hold tone
     * @memberof RingingService
     * @private
     */
    public stopHoldTone(): void {
        this.logger.debug(`[ringingService] stopHoldTone`);

        if (this.holdTone) {
            //if we're still starting the holdtone, try to stop it in a sec
            if (this.holdTone.starting) {
                if (!this.holdTone.stopDefered) {
                    this.logger.debug(`[ringingService] stopHoldTone: tone still starting: defer stop 1s later`);
                    this.holdTone.stopDefered = setTimeout(() => { this.stopHoldToneDefered(); }, 1000);
                } else {
                    this.logger.debug(`[ringingService] stopHoldTone: nothing to do : stop already defered`);
                }
                return;
            }

            //audio is not starting anymore: stop it, if it's playing
            this.holdTone.stopDefered = undefined;
            if (this.holdTone.audio && !this.holdTone.audio.paused) {
                this.logger.info(`[ringingService] stopHoldTone: tone is playing: stop it`);
                this.holdTone.audio.pause();
                this.holdTone.audio.currentTime = 0;
            } else {
                this.logger.debug(`[ringingService] stopHoldTone: nothing to do : tone is already stopped`);
            }
        }
    }

    // -------------------------------------------------------------
    //      IM Notification
    // -------------------------------------------------------------

    /**
     * Method playImNotif
     * Stop playing the the Web conference tone
     * @memberof RingingService
     * @private
     */
    public async playImNotif() {
        if (this.stopWebrtcSounds) {
            this.logger.info(`[ringingService] playImNotif is blocked...`);
            return;
        }

        if (!this.shouldPlayImNotif()) {
            this.logger.info(`[ringingService] playImNotif -- ignored`);
            return;
        }

        if (this.settingsService.getSetting("imSound")) {
            //play on secondary ringer device if necessary
            if (this.pingAudioSecondary
                && this.settingsService.getSetting("hasSecondRinger") === "true"
                && this.settingsService.getSetting("playMessagingNotifOnSecondaryRinger") === "true") {
                this.pingAudioSecondary.currentTime = 0;
                try {
                    await this.deviceManagementService.setSpeakerForAudioElement(this.pingAudioSecondary, this.deviceManagementService.getCurrentSecondaryOutputDevice());
                    this.logger.info(`[ringingService] playImNotif -- play Secondary`);
                    this.pingAudioSecondary.play();

                } catch (error) { /**/ }
            }

            //play on main ringer device
            if (this.pingAudio) {
                this.pingAudio.currentTime = 0;
                try {
                    await this.deviceManagementService.setSpeakerForAudioElement(this.pingAudio, this.deviceManagementService.getCurrentSpeaker());
                    this.logger.info(`[ringingService] playImNotif -- play Main`);
                    this.pingAudio.play();

                } catch (error) { /**/ }
            }
        }
    }

    // -------------------------------------------------------------
    //      Supervisor Notification
    // -------------------------------------------------------------

    /**
     * Method setActiveSupervisorAlarm
     * Set the specified notification as active for supervisor when supervisee receives an incoming call
     * @memberof RingingService
     * @private
     * @param {any} notif Name of the supervisor notification to set as active, one of defined in 'notifs' array
     */
    public setActiveSupervisorAlarm(id: string, type: string): void {
        this.logger.info(`[ringingService] setActiveSupervisorAlarm to ${id}`);

        this.contactService.userContact.customData.supervisorAlarm = id;
        if (id !== "noSound") {
            this.contactService.userContact.customData.supervisorAlarmType = type;
        }
        this.contactService.updateUserCustomData(this.contactService.userContact.customData);

        if (id && id !== "noSound" && type) {
            this.activeSupervisorRingingTone = { id, type, audio: new Audio() };
            this.activeSupervisorRingingToneSecondary = { id, type, audio: new Audio() };
            this.activeSupervisorRingingTone.audio.src = "/assets/sounds/" + type + "/" + id + this.audioFileType;
            this.activeSupervisorRingingToneSecondary.audio.src = "/assets/sounds/" + type + "/" + id + this.audioFileType;

            if (type === "alarms") {
                this.activeSupervisorRingingTone.audio.preload = "auto";
                this.activeSupervisorRingingTone.audio.currentTime = 0;
                this.activeSupervisorRingingTone.audio.loop = true;
                this.activeSupervisorRingingToneSecondary.audio.preload = "auto";
                this.activeSupervisorRingingToneSecondary.audio.currentTime = 0;
                this.activeSupervisorRingingToneSecondary.audio.loop = true;
            }
            this.logger.debug(`[ringingService] setActiveSupervisorAlarm -- supervisorAlarm set to ${id}`);
        }
        else {
            this.activeSupervisorRingingTone = null;
            this.activeSupervisorRingingToneSecondary = null;
            this.logger.info(`[ringingService] activeSupervisorAlarm set to null`);
        }
    }

    /**
     * Method playSupervisorNotif
     * Start playing the supervisor audio notif
     * @memberof RingingService
     * @private
     */
    public async playSupervisorNotif() {

        if (!this.shouldPlaySupervisorNotif()) {
            this.logger.info(`[ringingService] playSupervisorNotif not played because dnd`);
            return;
        }

        if (this.activeSupervisorRingingTone?.audio) {
            this.logger.info(`[ringingService] playSupervisorNotif`);
            this.activeSupervisorRingingTone.audio.currentTime = 0;
            this.activeSupervisorRingingToneSecondary.audio.currentTime = 0;

            // Play on secondary device (if second ringer configured configured)
            if (this.settingsService.getSetting("hasSecondRinger") === "true") {
                try {
                    await this.deviceManagementService.setSpeakerForAudioElement(this.activeSupervisorRingingToneSecondary.audio, this.deviceManagementService.getCurrentSecondaryOutputDevice());
                    this.logger.info(`[ringingService] playSupervisorNotif -- play Secondary`);
                    this.activeSupervisorRingingToneSecondary.audio.play();
                } catch (error) { /**/ }
            }

            // Play on main device
            try {
                await this.deviceManagementService.setSpeakerForAudioElement(this.activeSupervisorRingingTone.audio, this.deviceManagementService.getCurrentSpeaker());
                this.activeSupervisorRingingTone.audio.play();

            } catch (error) { /**/ }
        }
    }

    /**
     * Method playSupervisorRingingTone
     * Start playing the Supervisor ringing tone
     * @memberof RingingService
     * @private
     */
    public async playSupervisorRingingTone() {
        this.logger.info(`[ringingService] playSupervisorRingingTone...`);

        if (this.activeSupervisorRingingTone?.stopDefered) {
            //cancel defered stop operation
            this.logger.info(`[ringingService] playSupervisorRingingTone: cancel defered stop operation`);
            clearTimeout(this.activeSupervisorRingingTone.stopDefered);
            this.activeSupervisorRingingTone.stopDefered = undefined;
        }

        if ((this.activeSupervisorRingingTone?.audio) || (this.activeSupervisorRingingToneSecondary?.audio)) {

            // Play on secondary device
            if (this.settingsService.getSetting("hasSecondRinger") === "true") {
                this.activeSupervisorRingingToneSecondary.starting = true;
                try {
                    await this.deviceManagementService.setSpeakerForAudioElement(this.activeSupervisorRingingToneSecondary.audio, this.deviceManagementService.getCurrentSecondaryOutputDevice());
                    this.logger.info(`[ringingService] playSupervisorRingingTone secondary device -- play`);
                    this.play(this.activeSupervisorRingingToneSecondary);
                } catch (error) { /**/ }
            }

            // Play on main device
            if (this.activeSupervisorRingingTone?.audio?.paused && !this.activeSupervisorRingingTone.starting) {
                this.activeSupervisorRingingTone.starting = true;
                this.activeSupervisorRingingTone.audio.currentTime = 0;
                try {
                    await this.deviceManagementService.setSpeakerForAudioElement(this.activeSupervisorRingingTone.audio, this.deviceManagementService.getCurrentSpeaker());
                    this.logger.info(`[ringingService] playSupervisorRingingTone play`);
                    this.play(this.activeSupervisorRingingTone);
                } catch (error) { /**/ }
            } else {
                this.logger.info(`[ringingService] playSupervisorRingingTone -- nothing to do (already starting or playing)`);
            }
        }
    }

    /**
     * Method stopSupervisorRingingTone
     * Stop playing the Put On Hold tone
     * @memberof RingingService
     * @private
     */
    public stopSupervisorRingingTone(): void {
        this.logger.debug(`[ringingService] stopSupervisorRingingTone`);

        // stop ringing tone on main device
        if (this.activeSupervisorRingingTone) {
            //if we're still starting the holdtone, try to stop it in a sec
            if (this.activeSupervisorRingingTone.starting) {
                if (!this.activeSupervisorRingingTone.stopDefered) {
                    this.logger.debug(`[ringingService] stopSupervisorRingingTone: tone still starting: defer stop 1s later`);
                    this.activeSupervisorRingingTone.stopDefered = setTimeout(() => { this.stopSupervisorRingingToneDefered(); }, 1000);
                } else {
                    this.logger.debug(`[ringingService] stopSupervisorRingingTone: nothing to do : stop already defered`);
                }
                return;
            }

            //audio is not starting anymore: stop it, if it's playing
            this.activeSupervisorRingingTone.stopDefered = undefined;
            if (this.activeSupervisorRingingTone.audio && !this.activeSupervisorRingingTone.audio.paused) {
                this.logger.info(`[ringingService] stopSupervisorRingingTone: tone is playing: stop it`);
                this.activeSupervisorRingingTone.audio.pause();
                this.activeSupervisorRingingTone.audio.currentTime = 0;
            } else {
                this.logger.debug(`[ringingService] stopSupervisorRingingTone: nothing to do : tone is already stopped`);
            }
        }

        // stop ringing tone on secondary device
        if (this.activeSupervisorRingingToneSecondary) {
            //if we're still starting the supervisor secondary ringing tone, try to stop it in after 1 sec
            if (this.activeSupervisorRingingToneSecondary.starting) {
                if (!this.activeSupervisorRingingToneSecondary.stopDefered) {
                    this.logger.debug(`[ringingService] stopSupervisorRingingTone: secondary tone still starting: defer stop 1s later`);
                    this.activeSupervisorRingingToneSecondary.stopDefered = setTimeout(() => { this.stopSupervisorRingingToneSecondaryDefered(); }, 1000);
                } else {
                    this.logger.debug(`[ringingService] stopSupervisorRingingTone: nothing to do : secondary stop already defered`);
                }
                return;
            }

            // audio is not starting anymore: stop it, if it's playing
            this.activeSupervisorRingingToneSecondary.stopDefered = undefined;
            if (this.activeSupervisorRingingToneSecondary.audio && !this.activeSupervisorRingingToneSecondary.audio.paused) {
                this.logger.info(`[ringingService] stopSupervisorRingingTone: secondary tone is playing: stop it`);
                this.activeSupervisorRingingToneSecondary.audio.pause();
                this.activeSupervisorRingingToneSecondary.audio.currentTime = 0;
            } else {
                this.logger.debug(`[ringingService] stopSupervisorRingingTone: nothing to do : secondary tone is already stopped`);
            }
        }
    }

    /**
     * Method stopSupervisorRingingToneDefered
     * Stop playing the supervisor tone in a delayed way on main device
     * @memberof RingingService
     * @private
     */
    private stopSupervisorRingingToneDefered(): void {
        this.logger.debug(`[ringingService] stopSupervisorRingingToneDefered`);

        this.activeSupervisorRingingTone.stopDefered = undefined;
        this.stopSupervisorRingingTone();
    }

    /**
     * Method stopSupervisorRingingToneSecondaryDefered
     * Stop playing the supervisor tone in a delayed way on secondary device
     * @memberof RingingService
     * @private
     */
    private stopSupervisorRingingToneSecondaryDefered(): void {
        this.logger.debug(`[ringingService] stopSupervisorRingingToneSecondaryDefered`);

        this.activeSupervisorRingingToneSecondary.stopDefered = undefined;
        this.stopSupervisorRingingTone();
    }

    // -------------------------------------------------------------
    //      Conference Record tone
    // -------------------------------------------------------------

    /**
     * Method playRecordTone
     * Start playing the Conference Record tone
     * @memberof RingingService
     * @private
     */
    public async playRecordTone() {
        this.logger.info(`[ringingService] playRecordTone`);
        this.recordTone.currentTime = 0;

        try {
            await this.deviceManagementService.setSpeakerForAudioElement(this.recordTone, this.deviceManagementService.getCurrentSpeaker());
            this.recordTone.play();

        } catch (error) { /**/ }
    }

    // -------------------------------------------------------------
    //      Others
    // -------------------------------------------------------------

    /**
     * Method stopIncomingWebrtcSounds
     * Stop playing the WebRTC Incoming Call ringing tone
     * @memberof RingingService
     * @private
     */
    public stopIncomingWebrtcSounds(): void {
        this.stopWebrtcSounds = true;
    }

}
